import "./Terms.module.css";
import Header from "@/reusable_sections/Header";
import TermsOfUse from "./sections/TermsOfUse";
import Footer from "@/reusable_sections/Footer";
export default function TermsPage() {
  return <div>
      <Header />
      <TermsOfUse />
      <Footer />
    </div>;
}